import { render, staticRenderFns } from "./addBaseTask.vue?vue&type=template&id=50c70ffb&scoped=true"
import script from "./addBaseTask.vue?vue&type=script&lang=js"
export * from "./addBaseTask.vue?vue&type=script&lang=js"
import style0 from "./addBaseTask.vue?vue&type=style&index=0&id=50c70ffb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c70ffb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50c70ffb')) {
      api.createRecord('50c70ffb', component.options)
    } else {
      api.reload('50c70ffb', component.options)
    }
    module.hot.accept("./addBaseTask.vue?vue&type=template&id=50c70ffb&scoped=true", function () {
      api.rerender('50c70ffb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/addBaseTask.vue"
export default component.exports